import { render, staticRenderFns } from "./AddRulesRightPage.vue?vue&type=template&id=a1fd4862&scoped=true"
import script from "./AddRulesRightPage.vue?vue&type=script&lang=ts"
export * from "./AddRulesRightPage.vue?vue&type=script&lang=ts"
import style0 from "./AddRulesRightPage.vue?vue&type=style&index=0&id=a1fd4862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fd4862",
  null
  
)

export default component.exports